// extracted by mini-css-extract-plugin
export default {"component":"aen6G","background-opacity":"f9EYA","scrollOverlay":"U1KCu"};